module.exports = __webpack_public_path__ + "static/media/ab-de-villiers.909b1d95.jpg";